import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContenedoresService } from './../../../../../../../../services/API/contenedores/contenedores.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../../../../../services/notification-service/notification-service.service';
import { EditMantenimientoComponent } from './../edit-mantenimiento/edit-mantenimiento.component'; 

@Component({
    selector: 'app-new-mantenimiento',
    templateUrl: './new-mantenimiento.component.html',
    styleUrls: ['./new-mantenimiento.component.css'],
    standalone: false
})
export class NewMantenimientoComponent implements OnInit {

  showProgressBar: boolean = true;
  contenedores: any = [];
  contenedoresSearch: any = [];
  form: UntypedFormGroup;
  contenedor: any = -1;
  tipo: string;
  
  fechaAlta: any = new Date();
  fechaAltaFinal: any = "";
  fechaAccion: any = new Date();
  fechaAccionFinal: any = "";

  coste: string = '0';
  observaciones: string = '';
  estado: string = 'pending';

  constructor(private fb: UntypedFormBuilder, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService, 
              @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private dialogRef: MatDialogRef<NewMantenimientoComponent>) { }

  ngOnInit(): void {
    this.dateChangeAlta(this.fechaAlta);
    this.dateChangeAccion(this.fechaAccion);
    if(this.data['contenedor'] === 'all'){
      this.contenedor = -1;
    }else{
      this.contenedor = this.data['contenedor'];
    }
    this.getContenedores();
    this.form = this.fb.group({
      contenedor: [this.contenedor, [Validators.required, Validators.minLength(1)]],
      tipo: [this.tipo, [Validators.required, Validators.minLength(1)]],
      coste: [this.coste, [Validators.required, Validators.pattern("^[0-9]+(\\.[0-9]{1,2})?$")]],
      observaciones: [this.observaciones, [Validators.maxLength(128)]],
      estado: [this.estado, [Validators.required, Validators.minLength(1)]],
      fechaAlta: [this.fechaAlta, [Validators.required]],
      fechaAccion: [this.fechaAccion, [Validators.required]],  
    });
  }

  getContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getContenedores('all').subscribe(result => {
      this.showProgressBar = false;
      this.contenedores = result;
      this.contenedoresSearch = this.contenedores;
    });
  }

  filterSelect_Contenedores(value: string) { 
    this.contenedoresSearch =this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  save(saveAndEdit: boolean = false) {
    const {value, valid} = this.form;
    if(valid){
      this.showProgressBar = true;
      this.contenedoresService.newMantenimiento(value.contenedor.toString(), value.tipo, this.fechaAltaFinal, this.fechaAccionFinal, value.coste, value.observaciones, value.estado).subscribe(result => {
        this.notificationService.openSnackBar("Mantenimiento registrado correctamente!");
        this.showProgressBar = false;
        if(saveAndEdit === true){
          this.editMantenimiento(parseInt(result['id']), value.contenedor,value.tipo, this.fechaAltaFinal, this.fechaAccionFinal, value.coste, value.observaciones, value.estado);
        }
        this.close('save');
      });
    }else{
      this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
    }
  }

  editMantenimiento(id: number, contenedor: number, tipo: string, fechaAltaFinal: string, fechaAccionFinal: string, coste: string, observaciones: string, estado: string){
    const modifDialog = this.dialog.open(EditMantenimientoComponent, {
      data: {'mantenimiento': id, 'contenedor' : contenedor, 'tipo' : tipo, 'fechaAltaFinal' : fechaAltaFinal, 'fechaAccionFinal' : fechaAccionFinal, 'coste' : coste, 'observaciones' : observaciones, 'estado' : estado},
      width: '90%',
      maxWidth: '500px'
    });
    modifDialog.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.notificationService.openSnackBar("Mantenimiento actualizado correctamente!");
      }
    });
  }

  close(data: string = '') {
    this.dialogRef.close(data);
  }

  dateChangeAlta(event: any){
    let fecha: any;
    if(event instanceof Date) {
      fecha = event;
    }else {
      fecha = new Date(event.target.value);
    }
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaAltaFinal = fecha;
  }

  dateChangeAccion(event: any){
    let fecha: any;
    if(event instanceof Date) {
      fecha = event;
    }else {
      fecha = new Date(event.target.value);
    }
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaAccionFinal = fecha;
  }

}
